import { render, staticRenderFns } from "./VehicleCarryWeightEdit.vue?vue&type=template&id=68ff9a10&lang=pug"
import script from "./VehicleCarryWeightEdit.vue?vue&type=script&lang=js"
export * from "./VehicleCarryWeightEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports